<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<v-snackbar v-model="alert" top color="green" vertical :timeout=0>
    <div class="mb-3 title"><v-icon dark class="mr-2">notifications</v-icon>What's New</div>
    <div v-for="(txt, index) in newText" :key="index" class="ml-5">{{txt}}</div>
    <v-btn
      class="mt-0"
      color="white"
      text
      @click="closeAlert">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>

  export default {
    name: 'AlertBar',
    data: () => ({
      alert: false,
      version: "10",
      newText: ["- New graph for Hotspot Regions"]
    }),
    created() {
      //check localstorage for last version viewed
      if(localStorage.lastAlertVersion) {
        //found
        var ls = JSON.parse(localStorage.lastAlertVersion)
        if(ls !== this.version) {
          //this.alert = true
        }
      } 
      else {
        //this.alert = true
      }            
    },
    methods: {
      closeAlert() {
        this.alert = false

        //save to localstorage
        localStorage.lastAlertVersion = JSON.stringify(this.version)
      }
    }
  }
</script>

<style>
.v-snack__wrapper {
  width: 100%;
}
</style>